import React from 'react'
import { Icon } from '@/icons';


// 점수 상태를 표시하는 범례 컴포넌트
interface GradingStateProps {
    status: 'correct' // 정답
    | 'incorrect' // 오답
    | 'word_incorrect' // 오답
    | 'recording_incorrect' // 녹음 오답
    | 'both_incorrect' // 단어,녹음 오답
    | 'grading' // 채점 필요
    | 'partial_incorrect'; // 부분 오답 (오답률 포함)
    errorRate?: number; // 오답률 (0-100)
  }

  const GradingState = ({ status, errorRate }: GradingStateProps) => {
    const statusConfig = {
      correct: {  
        icon: 'circle',
        bgColor: 'bg-green-400',
        textColor: 'text-green-500',
        label: '정답'
      },
      incorrect: {
        icon: 'close',
        bgColor: 'bg-red-400',
        textColor: 'text-red-400',
        label: '오답'
      },
      word_incorrect: {
        icon: 'close',
        bgColor: 'bg-red-400',
        textColor: 'text-red-400',
        label: '오답'
      },
      recording_incorrect: {
        icon: 'close',
        bgColor: 'bg-red-400',
        textColor: 'text-red-400',
        label: '녹음 오답'
      },
      both_incorrect: {
        icon: 'close',
        bgColor: 'bg-red-400',
        textColor: 'text-red-400',
        label: '단어,녹음 오답'
      },
      grading: {
        icon: 'check',
        bgColor: 'bg-orange-500',
        textColor: 'text-orange-500',
        label: '채점 필요'
      },
      partial_incorrect: {
        icon: 'close',
        bgColor: 'bg-red-400',
        textColor: 'text-red-400',
        label: '오답'
      }
    };
  
    const config = statusConfig[status];
  const normalizedStatus =
    status === 'correct' ? 'correct' : status === 'grading' ? 'grading' : 'incorrect';
  
    return (
    <div className='flex gap-2 justify-center items-center' data-grading-status={normalizedStatus}>
        <span className={`flex justify-center items-center ${config.bgColor} rounded-full size-5`}>
          <Icon name={config.icon} className='text-white size-[14px]' />
        </span>
        <p className={`${config.textColor} text-sm whitespace-nowrap`}>
          {status === 'partial_incorrect' && errorRate !== undefined 
            ? `오답 ${errorRate}%` 
            : config.label}
        </p>
      </div>
    );
  }

export default GradingState;